var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInsightsIconActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FOR-DEV",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dev-company-info",
    transform: "translate(-40.000000, -386.000000)",
    fill: "#FFD110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(40.000000, 386.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-797",
    points: "5.45454545 11.8181818 9.09090909 11.8181818 9.09090909 9.73636364 5.45454545 7.99454545"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-798",
    points: "5.45454545 15.4545455 9.09090909 15.4545455 9.09090909 12.7272727 5.45454545 12.7272727"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-799",
    points: "4.54545455 11.8181818 4.54545455 8.45363636 1.50454545 11.8181818"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-800",
    points: "13.6363636 8.18181818 13.6363636 6.76181818 11.8609091 8.18181818"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-801",
    points: "10 9.66881818 10 11.8179091 13.6363636 11.8179091 13.6363636 9.09063636 10.7227273 9.09063636"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-802",
    points: "10 15.4545455 13.6363636 15.4545455 13.6363636 12.7272727 10 12.7272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1818182,9.09090909 L14.5454545,9.09090909 L14.5454545,11.8181818 L18.1818182,11.8181818 L18.1818182,12.7272727 L14.5454545,12.7272727 L14.5454545,15.4545455 L18.1818182,15.4545455 L18.1818182,16.3636364 L14.5454545,16.3636364 L14.5454545,19.0909091 L13.6363636,19.0909091 L13.6363636,16.3636364 L10,16.3636364 L10,19.0909091 L9.09090909,19.0909091 L9.09090909,16.3636364 L5.45454545,16.3636364 L5.45454545,19.0909091 L4.54545455,19.0909091 L4.54545455,16.3636364 L0.909090909,16.3636364 L0.909090909,15.4545455 L4.54545455,15.4545455 L4.54545455,12.7272727 L0.909090909,12.7272727 L0.909090909,2.27272727 C0.909090909,1.52090909 1.52090909,0.909090909 2.27272727,0.909090909 L16.8181818,0.909090909 C17.57,0.909090909 18.1818182,1.52090909 18.1818182,2.27272727 L18.1818182,5.14454545 L14.5454545,6.16181818 L14.5454545,8.18181818 L18.1818182,8.18181818 L18.1818182,9.09090909 Z M16.8181818,0 L2.27272727,0 C1.01909091,0 0,1.02 0,2.27272727 L0,17.7272727 C0,18.98 1.01909091,20 2.27272727,20 L16.8181818,20 C18.0718182,20 19.0909091,18.98 19.0909091,17.7272727 L19.0909091,2.27272727 C19.0909091,1.02 18.0718182,0 16.8181818,0 L16.8181818,0 Z",
    id: "Fill-803"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInsightsIconActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/insights_iconActive.d7a25fdcd45581138fa3fb5ff27af430.svg";